<template>
    <div class="container login">

        <!-- Logo and title -->
        <img src="https://wefix-files.s3.eu-west-2.amazonaws.com/images/logos/likewize/likewize-logo-pink.svg" alt="WeFix" class="logo" />
        <h1>Login</h1>

        <!-- Email input -->
        <div class="form-group">
            <input type="email" class="form-control form-control-lg" v-model="email" placeholder="Email">
        </div>

        <!-- Password input -->
        <div class="form-group">
            <input type="password" class="form-control form-control-lg" v-model="password" v-on:keyup.enter="login()" placeholder="Password">
        </div>

        <!-- Login button -->
        <div class="row">
            <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                <button type="submit" class="btn btn-success btn-block btn-lg btn-rounded" @click="login()">Log in</button>
            </div>
        </div>

        <div class="disclaimer-text">
            <p>
                *Only authorised users can access this system and legal action may be taken against unauthorised users, under the computer misuse act of 1990.
            </p>
        </div>

    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import firebaseAuth from '@/services/firebaseAuth';

    export default {
        name: "LoginIndex",

        data: function() {
            return {
                email: null,
                password: null
            }
        },

        methods: {
            ...mapActions(['fetchUser', 'displayToast']),

            login() {
                if (!this.email || !this.password) {
                    this.displayToast({text: 'Enter your login credentials.', type: 'error'});
                    return;
                }

                this.fetchUser({email: this.email, password: this.password})
                    .then(() => {
                        // Exchange the fresh Laravel session for a Firebase one
                        // before leaving the login screen, so that a refusal is
                        // reported here rather than as a wall of permission
                        // errors on the dashboard.
                        return firebaseAuth.signIn();
                    })
                    .then(() => {
                        window.location.href = '/';
                    })
                    .catch(errors => {
                        if (firebaseAuth.isForbidden(errors)) {
                            this.clearSession('You are not authorised to use this app.');
                            return;
                        }

                        if (firebaseAuth.isAccessDenied(errors)) {
                            this.clearSession('Your session could not be verified. Please log in again.');
                            return;
                        }

                        this.displayToast({text: this.messageFor(errors), type: 'error'});
                    })
            },

            clearSession(message) {
                this.displayToast({text: message, type: 'error'});

                return Promise.all([
                    this.$store.dispatch('clearUser'),
                    firebaseAuth.signOut()
                ]);
            },

            messageFor(errors) {
                if (typeof errors === 'string') {
                    return errors;
                }

                return 'Could not sign you in. Please try again.';
            }
        }
    }
</script>